import { crossCategoryLinkSelector } from '@client/redux/experiments/selectors/cross-category-link';
import { useAppSelector } from '@redux/hooks';

export const useIsCrossCategoryLinkEnabled = () => {
	const assignment = useAppSelector(crossCategoryLinkSelector);
	return assignment === 'variant1';
};
